import {
  AppLanguageOptionsSubset,
  AppLanguageOptionsSubsetEnum,
} from "../../app/models/constants/app-language-options.const";

export const normalizeLanguage = (lang: string): AppLanguageOptionsSubsetEnum => {
  const l = lang?.toLowerCase();

  if (l.startsWith("de")) {
    return "de";
  }

  if (l.startsWith("fr")) {
    return "fr";
  }

  return "en";
};

export const pickLanguageValue = (
  values: Record<string, string> | undefined,
  lang: AppLanguageOptionsSubsetEnum,
): string => {
  if (!values) {
    return "";
  }

  return values[lang] ?? values["en"] ?? values["de"] ?? values["fr"] ?? "";
};

const getTrimmedMultiLangValues = (values: Record<string, string> | null | undefined): string[] =>
  AppLanguageOptionsSubset.map(lang => (values?.[lang] ?? "").trim());

export const validateLength = (
  values: Record<string, string> | null | undefined,
  maxLength: number,
): { invalid: boolean; tooLong: boolean } => {
  const trimmedValues = getTrimmedMultiLangValues(values);

  return {
    invalid: trimmedValues.some(value => value.length === 0),
    tooLong: trimmedValues.some(value => value.length > maxLength),
  };
};
